import React from 'react';

const MongoDB_GetStarted = () => {
  return (
    <div>
      <h1>MongoDB_GetStarted Component</h1>
      <p>This is the MongoDB_GetStarted page.</p>
    </div>
  );
};

export default MongoDB_GetStarted;
